import { AuthAction } from "../actions/authActions";
import { jwtDecode } from "jwt-decode";

interface AuthState {
	accessToken: string | null;
	id: string | null;
	username: string | null;
	email: string | null;
	exp: number | null;
	permissions: string[];
}

// JWT token'ından gelen claims için özel interface
interface CustomJwtPayload {
	exp: number;
	iss: string;
	nbf: number;
	'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier': string;
	'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress': string;
	'http://schemas.microsoft.com/ws/2008/06/identity/claims/role': string;
	permissions: string[];
}

const initialState: AuthState = {
	accessToken: null,
	id: null,
	username: null,
	email: null,
	exp: null,
	permissions: [],
};

const authReducer = (state = initialState, action: AuthAction): AuthState => {
	switch (action.type) {
		case 'LOGIN':
			const decoded = jwtDecode<CustomJwtPayload>(action.payload.accessToken);
			const userId = decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier']?.replace(/['"]+/g, '');
			const email = decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'];
			localStorage.setItem("userId", userId || '');

			return {
				...state,
				...decoded,
				id: userId,
				email: email,
				...action.payload
			};
		case 'LOGOUT':
			localStorage.removeItem('userId');
			return { ...initialState };
		default:
			return state;
	}
};

export default authReducer;